import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Typography, Section } from '@miro-site/ui-design-system';
import { Cta } from '@miro-site/components_cta';
import '@miro-site/shared-types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var SectionWithCta = function SectionWithCta(_ref) {
  var title = _ref.title,
      cta = _ref.cta;

  var content = /*#__PURE__*/_jsxs("div", {
    className: "d-flex align-items-center justify-content-between",
    children: [/*#__PURE__*/_jsx(Typography, {
      className: "mb-0",
      color: "white",
      children: title
    }), /*#__PURE__*/_jsx(Cta, _objectSpread({}, cta))]
  });

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Section, {
      bg: "info-idle",
      wrapperClassName: "p-200 d-block d-sm-none ms-n300 me-n300",
      children: content
    }), /*#__PURE__*/_jsx(Section, {
      bg: "info-idle",
      wrapperClassName: "p-200 rounded-1 d-none d-sm-block",
      children: content
    })]
  });
};

export default SectionWithCta;
export { SectionWithCta };